import * as yup from 'yup';

const initialValues = {
  comment: '',
};

const validationSchema = yup.object().shape({
  comment: yup.string().test('not-empty', 'Comment is required', value => {
    // Remove all HTML tags and whitespace
    const plain = value?.replace(/<(.|\n)*?>/g, '').trim();
    return !!plain;
  }),
});

export { initialValues, validationSchema };
